import getVisibilityImage from './getVisibilityImage'
import getSubStatusImage from './getSubStatusImage'
import getMarkerImage from './getMarkerImage'
import getFatigue from './getFatigue'

import store from '../store/index'

function normalizeCombatantImage(imageUrl, baseUrlOverride = '') {
  if (!imageUrl || /^https?:\/\//i.test(imageUrl)) {
    return imageUrl
  }

  const baseUrl =
    baseUrlOverride ||
    import.meta.env.VITE_API_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '')

  if (!baseUrl) {
    return imageUrl
  }

  try {
    return new URL(imageUrl, baseUrl).toString()
  } catch {
    return imageUrl
  }
}

function serializeCombatImageDebugValue(value) {
  if (value === undefined) {
    return '__undefined__'
  }

  if (value === null) {
    return '__null__'
  }

  if (value === '') {
    return '__blank__'
  }

  return value
}

function serializeCombatImageDebug(details = {}) {
  return JSON.stringify(
    Object.entries(details).reduce((serializedDetails, [key, value]) => {
      serializedDetails[key] = serializeCombatImageDebugValue(value)
      return serializedDetails
    }, {}),
  )
}
//--------------------------------
// load specific combatant images
//--------------------------------
export default function loadSpecificCombatantImages(parm) {
  // console.log("---------------------");
  // console.log("IN loadSpecificCombatantImages idx = " + parm.idx);
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let combatants = this_store.arena.arena_combatants

  if (
    combatants?.[parm.idx] &&
    (parm.img === null ||
      parm.img?.image === null ||
      parm.img?.image === undefined ||
      parm.img?.image === '' ||
      (typeof parm.img?.image === 'string' && parm.img.image.startsWith('/media/')) ||
      combatants[parm.idx].image === null ||
      combatants[parm.idx].image === undefined ||
      combatants[parm.idx].image === '' ||
      (typeof combatants[parm.idx].image === 'string' &&
        combatants[parm.idx].image.startsWith('/media/')))
  ) {
    console.log(
      '[combat-image-debug][loadSpecificCombatantImages][before] ' +
        serializeCombatImageDebug({
          idx: parm.idx,
          name: combatants[parm.idx].name,
          incomingParmImage: parm.img?.image || null,
          existingStoreImage: combatants[parm.idx].image,
        }),
    )
  }
  //---------------------------------------
  // load combatant image (where provided)
  //---------------------------------------
  if (parm.img) {
    combatants[parm.idx].image = normalizeCombatantImage(parm.img.image, combatants[parm.idx].image)
  }
  //-----------------------
  // load sub-status image
  //-----------------------
  let sub_status_image = getSubStatusImage(combatants[parm.idx].sub_status)
  combatants[parm.idx].sub_status_image = sub_status_image
  //-----------------------
  // load visibility image
  //-----------------------
  let visibility_image = getVisibilityImage(combatants[parm.idx].visibility)
  combatants[parm.idx].visibility_image = visibility_image
  //--------------------
  // load fatigue image
  //--------------------
  let fatigue = getFatigue(combatants[parm.idx].fatigue)
  combatants[parm.idx].fatigue_image = fatigue.image
  //---------------------
  // load bleeding image
  //---------------------
  let bleeding_image = getMarkerImage('bleeding')
  combatants[parm.idx].bleeding_image = bleeding_image
  //---------------------
  // load surprise image
  //---------------------
  let surprise_image = getMarkerImage('surprised')
  combatants[parm.idx].surprise_image = surprise_image

  if (
    combatants?.[parm.idx] &&
    (combatants[parm.idx].image === null ||
      combatants[parm.idx].image === undefined ||
      combatants[parm.idx].image === '' ||
      (typeof combatants[parm.idx].image === 'string' &&
        combatants[parm.idx].image.startsWith('/media/')))
  ) {
    console.log(
      '[combat-image-debug][loadSpecificCombatantImages][after] ' +
        serializeCombatImageDebug({
          idx: parm.idx,
          name: combatants[parm.idx].name,
          finalStoreImage: combatants[parm.idx].image,
          subStatus: combatants[parm.idx].sub_status,
          fatigue: combatants[parm.idx].fatigue,
        }),
    )
  }
}
